import { lazy, Suspense, useMemo, useRef } from 'react';
import * as React from 'react';
import YouTubePlayer from 'youtube-player';

import useLiveVideo from '@/hooks/race/useLiveVideo';
import { Velodrome } from '@/modelTypes';

import { IFrame, Wrapper } from './style';

const KeirinJpLiveVideo = lazy(() => import('./KeirinJpLiveVideo'));

export interface LiveMovieProps {
  velodrome: Velodrome;
  device: 'pc' | 'sp';
}

/**
 * デバイスごとの表示優先度
 * SP: YoutubeLive -> KeirinJP
 * PC: YoutubeLiveのみ
 */
export const LiveMovie: React.FC<LiveMovieProps> = React.memo(
  ({ velodrome, device }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const isMobile = useMemo(() => device === 'sp', [device]);

    const { isReplaced, liveUrl, liveVideoInfo, muted, setMuted } =
      useLiveVideo(velodrome);

    const onPlayerVolumeChange = (event: any) => {
      setMuted(event.data.muted);
    };

    const loadYoutubeVideo = () => {
      if (iframeRef.current) {
        const player = YouTubePlayer(iframeRef.current);
        player.on('volumeChange', onPlayerVolumeChange);

        if (muted) {
          player.mute();
        } else {
          player.unMute();
        }
      }
    };

    if (!liveVideoInfo.embeddable) {
      return <></>;
    }

    if (liveVideoInfo.embeddableYoutube || isReplaced) {
      return (
        <Wrapper>
          <IFrame
            src={liveUrl}
            title={`${velodrome.name}競輪 ${
              isReplaced ? 'DMM競輪ライブ動画' : 'ライブ動画'
            }`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            onLoad={() => loadYoutubeVideo()}
            ref={iframeRef}
          />
        </Wrapper>
      );
    }

    if (!liveVideoInfo.embeddableYoutube && isMobile) {
      return (
        <Wrapper>
          <Suspense fallback={<></>}>
            <KeirinJpLiveVideo
              velodromeCode={velodrome.code}
              muted={muted}
              setMuted={setMuted}
            />
          </Suspense>
        </Wrapper>
      );
    }

    return <></>;
  },
);

export default LiveMovie;
